// extracted by mini-css-extract-plugin
module.exports = {"contentComponent":"QuizzesList_contentComponent__2HwNe"};